<!--
 * @Author: rossdong rossdong@yntengyun.com
 * @Date: 2025-04-17 17:50:11
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @LastEditTime: 2026-04-16 15:38:52
 * @FilePath: /Mobile/src/pages/complaint/views/visual/disposalAnalysis/index.vue
 * @Description: 处置情况分析
 *
-->

<template>
  <div class="w-full flex flex-col px-16 pb-49">
    <AreaCell ref="areaCellRef" />
    <SatisfactionCell ref="satisfactionCellRef" class="mt-4" />

    <CompleteCountCell ref="completeCountCellRef" class="mt-4" />
    <Complete24HoursCountCell ref="complete24HoursCountCellRef" class="mt-4" />
    <FirstPointResponseAvegerCell ref="firstPointResponseAvegerCellRef" class="mt-4" />
    <FirstPointAreaCell ref="firstPointAreaCellRef" class="mt-4" />
  </div>
</template>

<script>
import AreaCell from './comps/AreaCell.vue';
import FirstPointAreaCell from './comps/FirstPointAreaCell.vue';
import SatisfactionCell from './comps/SatisfactionCell.vue';
import CompleteCountCell from './comps/CompleteCountCell.vue';
import Complete24HoursCountCell from './comps/Complete24HoursCountCell.vue';
import FirstPointResponseAvegerCell from './comps/FirstPointResponseAvegerCell.vue';

export default {
  components: {
    AreaCell,
    FirstPointAreaCell,
    SatisfactionCell,
    CompleteCountCell,
    Complete24HoursCountCell,
    FirstPointResponseAvegerCell
  },
  data() {
    return {
    }
  },
  computed: {
    deptInfo() {
      return this.$store.state.complaint.deptInfo;
    }
  },
  mounted() {
    // 各个 Cell 已通过 visualFilterMixin 实现自动按需加载，此处无需手动调用
  }
};
</script>

<style lang="less" scoped>
.wrap {
  margin: 0 12px 12px;
  margin-bottom: 49px;
}
</style>
